import { render, staticRenderFns } from "./ImageAudioVideo.vue?vue&type=template&id=1888c994&"
import script from "./ImageAudioVideo.vue?vue&type=script&lang=js&"
export * from "./ImageAudioVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports